import { styled } from "@mui/material/styles";
import backArrowIcon from "assets/images/icons/arrow-short.svg";
import { PlainButton } from "components/button/plain";

export const MWebAddons = styled("div", {
  label: "mweb-add-ons",
})`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.2;
  margin-bottom: 15px;
  margin-top: ${({ theme }) => theme.spacing(1.125)};
  color: ${({ theme }) => theme.palette.primary.main};
  position: relative;

  ${({ theme }) => theme.breakpoints.down("md")} {
    &::after {
      content: "";
      position: absolute;
      left: -${({ theme }) => theme.spacing(4)};
      right: 0;
      top: ${({ theme }) => theme.spacing(4.5)};
      height: ${({ theme }) => theme.spacing(0.125)};
      background-color: ${({ theme }) => theme.palette.color.gray[90]};
      width: 100vw;
    }
  }
`;

export const ArrowIcon = styled(backArrowIcon, {
  label: "arrow-icon",
})`
  fill: currentColor;
  width: ${({ theme }) => theme.spacing(2)};
  stroke: currentColor;

  &.right {
    transform: rotate(-180deg);
  }
`;

export const SeeMoreButton = styled(PlainButton, {
  label: "see-more-button",
})`
  border-radius: 50%;
  display: flex;
  width: ${({ theme }) => theme.spacing(3)};
  height: ${({ theme }) => theme.spacing(3)};
  transition: ${({ theme }) => theme.transitions.create("background")};

  border: 1px solid ${({ theme }) => theme.palette.color.primary[90]};
  margin-left: ${({ theme }) => theme.spacing(1)};
  &:hover {
    background: ${({ theme }) => theme.palette.action.hover};
  }
`;
